module.exports = __webpack_public_path__ + "img/admin.3ff6d63f.svg";